module.exports = __webpack_public_path__ + "static/assets/c296552f9440b25b8225da38a14d9488.png";